import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import Header from "../Header";
import SectionLayout from "../../layouts/SectionLayout";
import SlideTransition from "../SlideTransition";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";
import { MAIN_ROUTES } from "../../utils/routes";

import { styles } from "./style";

const ContactSection = () => {
  const content = useContent();
  const [setRef, visible] = useInView({
    threshold: 0.5,
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <SectionLayout
      style={{
        pb: { xs: 8, md: 12 },
        pt: { xs: 6, md: 8 },
        zIndex: 99,
      }}
    >
      <Stack ref={setRef} sx={styles.contactRoot}>
        <Stack spacing={0} sx={styles.contactCard}>
          <Stack
            alignItems={"center"}
            spacing={10}
            sx={{ width: { xs: "100%", md: "30%" } }}
          >
            <SlideTransition appear={visible} timeout={800}>
              <Stack spacing={3}>
                <Header
                  center={matches ? true : true}
                  data={content.contact}
                  decorationPos={"bottom"}
                  // style={{ color: theme.palette.grays["white"] }}
                />

                <Typography sx={styles.bodyText}>
                  {content.contact.content}
                </Typography>
              </Stack>
            </SlideTransition>

            <SlideTransition appear={visible} timeout={900}>
              <Link to={MAIN_ROUTES.get("CONTACT").PATH}>
                <Button
         
                  sx={styles.button}
                  variant="contained"
                >
                  {content.contact.action}
                </Button>
              </Link>
            </SlideTransition>
          </Stack>
        </Stack>
        <Box sx={styles.background} />
      </Stack>
    </SectionLayout>
  );
};

export default ContactSection;
